import React from 'react';
import { reactLocalStorage } from 'reactjs-localstorage';
import Table from 'react-bootstrap/Table';
import { FaList, FaPencilAlt, FaTrash } from 'react-icons/fa';
import Const from '../../util/Constants';
import PropertyAPI from '../../api/PropertyAPI';
import Util from '../../util/Util';
import DB from '../../util/LocalDB';
import ApiUiController from '../../controller/ApiUiController';
import ActionController from '../../controller/ActionController';
import Display from '../../util/Display';
import LeadConst from '../../util/LeadConst';
import PropertyConst from "../../util/PropertyConst";
import { Badge } from 'react-bootstrap';

class InnerLeadPreviewPropertyList extends React.Component {

  constructor(props) {
    super(props);
    this.model = reactLocalStorage.getObject(Const.Model).property;
    this.state = { inApiCall: true, property: [] };
    this.filter = [];
    const user = parseInt(reactLocalStorage.getObject(Const.LoggedInUser).user_id);
    this.User = Const.Opt + user + Const.Opt;

    this.View = Util.isAllow(this.model.permission, Const.PermView);
    this.Update = Util.isAllow(this.model.permission, Const.PermUpdate);
    this.Delete = Util.isAllow(this.model.permission, Const.PermDelete);
    this.Restrict = Util.isAllow(this.model.permission, Const.PermInnerListRestrict);
    this.fields = Object.keys(this.model.fields).map(key => this.model.fields[key]).filter(field => field.editable && ['name', 'property_type', 'property_transaction', 'property_is', 'possession_type', 'price', 'property_status', 'referance'].includes(field.field_key))
      .sort((l, r) => l.field_order - r.field_order);

    this.actions = DB.getActions(Const.Property);
  }

  onProperties = () => {
    const lead = this.props.lead;
    const filter = [];

    if (lead.min_budget && lead.max_budget) filter.push({
      field: 'price', type: 'decimal',
      condition: 'in', value: `${lead.min_budget}~${lead.max_budget}`
    });
    else if (lead.min_budget) filter.push({
      field: 'price', type: 'decimal',
      condition: 'start-with', value: `${lead.min_budget}~`
    });
    else if (lead.max_budget) filter.push({
      field: 'price', type: 'decimal',
      condition: 'end-with', value: `~${lead.max_budget}`
    });

    if (lead.property_transaction) filter.push({
      field: 'property_transaction', type: 'select',
      condition: 'in', value: `${lead.property_transaction}`
    });

    if (lead.property_is) filter.push({
      field: 'property_is', type: 'select',
      condition: 'in', value: `${lead.property_is}`
    });

    if (lead.property_type) filter.push({
      field: 'property_type', type: 'select',
      condition: 'in', value: `${lead.property_type}`
    });
    if (lead.area) filter.push({
      field: 'area', type: 'select',
      condition: 'in', value: `${lead.area}`
    });
    return filter;
  };

  componentDidMount() { this.loadProperties(); }

loadProperties = property => {
  const filter = this.onProperties();
  filter.length > 0 
    ? PropertyAPI.list({ filters: filter, pagination: { currentPage: 1, perPage: 20 } }, this.onReceived, this.props.failure, this.props.logout)
    : this.setState({ inApiCall: false, property: [] }); // Set empty array, not 0
};
  onReceived = res => {
    if (this.props.onCount) {
      this.props.onCount('property', res.count);
    }
    this.setState({ inApiCall: false, property: res.data });
  };
  onFail = (res) => {
    const message = res.message ? JSON.stringify(res.message) : 'Something went wrong';
    Util.showError(message);
    this.setState({ ...this.state, inApiCall: false });
  };
  // onDelete = indx => Util.confirmAlert('Delete', 'Are you sure you want to delete',
  //   'Delete', 'No', () => {
  //     this.setState({ ...this.state, inApiCall: true });
  //     MeetingAPI.delete(this.state.meetings[indx].id, this.onDeleteSuccess, this.onFail);
  //   });
  onDeleteSuccess = () => {
    Util.showNotification('Successful', 'Property deleted successfully', 'success');
    this.props.reload();
  };
  onPreview = index => {
    this.props.navigate(`/property/preview/${index}`);
  };
  showList = () => this.state.property && this.state.property.map((property, _i) =>
    <tr key={`property_${_i + 1}`}>
      {this.fields.map((field, _j) => <td key={`i_${_i}_${_j}`}>{Display.FieldValue(property, field.field_key, this.model.fields)}</td>)}
      <td>
        {ActionController.checkAction(Const.PermView, this.View, this.actions, this.props.data) ?
          <span onClick={(evt) => this.onPreview(property.id)} className="buttons update buttons-sm">
            <FaList /> View
          </span> : null}
        {/* {ActionController.checkAction(Const.PermUpdate, this.Update, this.actions, property) ?
          <span onClick={evnt => this.props.edit(property, LeadConst.Property)} className="buttons update buttons-sm">
            <FaPencilAlt /> edit
          </span>
          : null
        } */}
      </td>
    </tr >
  );

  render() {
    let uiProperty = this.showList();
    if (this.state.property.length === 0) {
      uiProperty = <tr><td colSpan={this.fields.length + 1}>No Records Found</td></tr>;
    }
    return (
      <div className="row">
        <div className="col-md-12">
          <h2>{this.model.model_name}</h2>
          <ApiUiController inApiCall={this.state.inApiCall}>
            <Table striped bordered hover>
              <thead>
                <tr>
                  {this.fields.map((field, i) => <th key={`h_${i}`}>{field.label_name}</th>)}
                  <th className="actionth">Action</th>
                </tr>
              </thead>
              <tbody>
                {uiProperty}
              </tbody>
            </Table>
          </ApiUiController>
        </div>
      </div>
    );
  }
}

export default InnerLeadPreviewPropertyList;